import instance from "../../utils/axios";

const toFormData = (payload = {}) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => {
    if (val === undefined || val === null) return;
    if (Array.isArray(val)) {
      formData.append(key, JSON.stringify(val));
    } else {
      formData.append(key, String(val));
    }
  });
  return formData;
};

export const readEntityContentAnalytics = async (payload = {}) => {
  const response = await instance.post(
    "/entity/content/analytics/read",
    toFormData(payload)
  );
  return response.data;
};

export const readEntityContentDetails = async (payload = {}) => {
  const response = await instance.post(
    "/entity/content/details/read",
    toFormData(payload)
  );
  return response.data;
};

export const readEntityContentViewsAnalytics = async (payload = {}) => {
  const response = await instance.post(
    "/entity/content/views/analytics/read",
    toFormData(payload)
  );
  return response.data;
};

export const readEntityContentViewsTrending = async (payload = {}) => {
  const response = await instance.post(
    "/entity/content/views/trending/read",
    toFormData(payload)
  );
  return response.data;
};

export const readEntityContentViewsDetails = async (payload = {}) => {
  const response = await instance.post(
    "/entity/content/views/details/read",
    toFormData(payload)
  );
  return response.data;
};
